/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, forwardRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import Loader from '../../../utils/Loader'
import { fill_action } from '../../../actions/fillList_action';
import { roleActionId, StatusActionId, downloadReport, sessionExpireMessage, tokenInavlidMessage } from '../../../utils/constants';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { accountReceipt_list_action, delete_accountReceipt_list_action, download_account_receipt_action } from '../../../actions/accounts_action/account_receipts_action'
import { ToastContainer, toast, } from 'react-toastify';
import Pagination from "../../../utils/pagination";
import moment from 'moment'
import Header from '../../../common_components/Header';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
class AccountReceiptsList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isAccordionExpanded: false,
            accountRecieptList: [],
            currentPage: 1,
            recieptDate: '',
            dateRange: [
                {
                    startDate: new Date(),
                    endDate: new Date(),
                    key: 'selection'
                }
            ],
            client: '',
            receiptFromDate: '',
            receiptToDate: '',
            receiptNo: '',
            show: false,
            UserId: '',
            ReceiptId: '',
        }
        this.updateItem = this.updateItem.bind(this)
        this.modalClose = this.modalClose.bind(this)
        this.modalShow = this.modalShow.bind(this)
        this.downloadAccountReceipt = this.downloadAccountReceipt.bind(this)
    }

    componentDidMount() {

        if (JSON.parse(sessionStorage.getItem('UserLoginData')) == null) {
            console.log('log')
            setTimeout(() => {
                this.props.navigate('/login')
            }, 500);
        }

        setTimeout(() => {
            {
                sessionStorage.getItem("roleId") == 4 ?
                    this.props.navigate('/checkList') :
                    <></>
            }
        }, 10);

        setTimeout(() => {
            {
                sessionStorage.getItem("roleId") == 4 ?
                    this.props.navigate('/checkList') :
                    <></>
            }
        }, 10);

        this.setState({
            client: localStorage.getItem("client"),
            receiptFromDate: localStorage.getItem("receiptFromDate"),
            receiptToDate: localStorage.getItem("receiptToDate"),
            receiptNo: localStorage.getItem("receiptNo")
        })
        this.getAccountrecieptList()

        setTimeout(() => {
            const { client, receiptFromDate, receiptToDate, receiptNo } = this.state
            client != '' && receiptFromDate != '' && receiptToDate != '' && receiptNo != '' ? this.handleClear() : <></>
        }, 100);
    }

    getAccountrecieptList() {
        const { client, receiptFromDate, receiptToDate, receiptNo } = this.state

        this.setState({ isLoading: true })
        this.props
            .accountReceipt_list_action(client, receiptFromDate, receiptToDate, receiptNo)
            .then((data) => {
                if (data.error != 1) {
                    // console.log("accountRecieptList", data.data)
                    this.setState({ accountRecieptList: data.data })
                    this.setState({ isLoading: false })
                }
                else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear()
                        this.props.navigate('/normalView')
                        setTimeout(() => {
                            toast.error(data.msg, {
                                position: "top-center",
                                theme: "colored",
                                autoClose: 3000,
                                hideProgressBar: true,
                            });
                        }, 500);
                    } else {
                        this.setState({ isLoading: false })
                        toast.error(data.data, {
                            theme: 'colored',
                            autoClose: 3000,
                            hideProgressBar: true,
                        })
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });

        localStorage.setItem("client", client)
        localStorage.setItem("receiptFromDate", receiptFromDate)
        localStorage.setItem("receiptToDate", receiptToDate)
        localStorage.setItem("receiptNo", receiptNo)
    }

    downloadAccountReceipt(userId, receiptId, receiptNo) {
        this.setState({ isLoading: true })
        this.props
            .download_account_receipt_action(userId, receiptId, receiptNo)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    console.log(data)
                    var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
                    const win = window.location.replace(url, '_blank');
                    if (win != null) {
                        win.focus();
                    }
                }
                else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear()
                        this.props.navigate('/normalView')
                        setTimeout(() => {
                            toast.error(data.msg, {
                                position: "top-center",
                                theme: "colored",
                                autoClose: 3000,
                                hideProgressBar: true,
                            });
                        }, 500);
                    } else {
                        this.setState({ isLoading: false })
                        toast.error(data.data, {
                            theme: 'colored',
                            autoClose: 3000,
                            hideProgressBar: true,
                        })
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    deleteAccountReceiptList(userId, receiptId) {
        this.setState({ isLoading: true })
        this.props
            .delete_accountReceipt_list_action(userId, receiptId)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false, show: false })
                    this.props.navigate('/accountReceiptsList')
                    this.getAccountrecieptList()
                    toast.success("Deleted SuccessFully!", {
                        theme: 'colored',
                        autoClose: 3000,
                        hideProgressBar: true,
                    })
                }
                else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear()
                        this.props.navigate('/normalView')
                        setTimeout(() => {
                            toast.error(data.msg, {
                                position: "top-center",
                                theme: "colored",
                                autoClose: 3000,
                                hideProgressBar: true,
                            });
                        }, 500);
                    } else {
                        this.setState({ isLoading: false })
                        toast.error(data.data, {
                            theme: 'colored',
                            autoClose: 3000,
                            hideProgressBar: true,
                        })
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    modalShow = (userId, receiptId) => {
        const confirmed = window.confirm(
            "Do you really want to delete this record?"
        );

        if (confirmed) {
            this.deleteAccountReceiptList(userId, receiptId)
        }
    };
    modalClose = () => {
        this.setState({ show: false });
    };

    updateItem(item) {
        this.setState({ currentPage: item });
    }

    addAccountReceipt() {
        this.setState({
            client: localStorage.removeItem("client"),
            receiptFromDate: localStorage.removeItem("receiptFromDate"),
            receiptToDate: localStorage.removeItem("receiptToDate"),
            receiptNo: localStorage.removeItem("receiptNo")
        })
        this.props.navigate('/accountReceiptsAU', { state: { Is_add: true, Is_update: false } })
    }

    updateAccountReceipt(userId, clienId, receiptId, ReceiptDetailID) {
        this.props.navigate('/accountReceiptsAU', { state: { Is_update: true, UserId: userId, ClientID: clienId, ReceiptId: receiptId, isGenVoucherDisabled: true, isEditGenerateVoucher: true, ReceiptDetailID: ReceiptDetailID } })
    }

    onPreviewNavigate(userId, clienId, receiptId,ReceiptDetailID) {
        this.props.navigate('/accountReceiptsAU', { state: { onPreview: true, UserId: userId, ClientID: clienId, ReceiptId: receiptId, isEditGenerateVoucher: true, ReceiptDetailID: ReceiptDetailID } })
    }

    chooseDate(item) {
        this.setState({ dateRange: [item.selection] })
        this.setState({
            receiptFromDate: item.selection['startDate'] != null ? moment(item.selection['startDate']).format('YYYY-MM-DD') : <></>,
            receiptToDate: item.selection['endDate'] != null ? moment(item.selection['endDate']).format('YYYY-MM-DD') : <></>
        })
    }

    handleClear() {
        this.setState({
            client: '',
            receiptFromDate: '',
            receiptToDate: '',
            receiptNo: '',
            dateRange: [
                {
                    startDate: new Date(),
                    endDate: new Date(),
                    key: 'selection'
                }
            ]
        })

        setTimeout(() => {
            this.getAccountrecieptList()
        }, 10);
    }

    record(accountRecieptList) {
        const aList = accountRecieptList

        accountRecieptList.map((data, i) => {
            var tempReceiptNo = data['ReceiptNo']
            if (tempReceiptNo.includes('/')) {
                tempReceiptNo = tempReceiptNo.replace('/', '_')
                data.tempReceiptNo = tempReceiptNo
                if (tempReceiptNo.includes('/')) {
                    tempReceiptNo = tempReceiptNo.replace('/', '_')
                    data.tempReceiptNo = tempReceiptNo
                    if (tempReceiptNo.includes('/')) {
                        tempReceiptNo = tempReceiptNo.replace('/', '_')
                        data.tempReceiptNo = tempReceiptNo
                    }
                }
            }
        })
        console.log("newList accountRecieptList", accountRecieptList)

        return (

            <table class="table table-bordered table-striped" id="dashboard-table">
                <thead>
                    <tr>
                        <th>Receipt No</th>
                        <th>Organizer Name</th>
                        <th>Receipt Date</th>
                        {/* <th style={{ width: '12%' }}>Additional Services Amount</th> */}
                        <th style={{ width: '10%' }}> Taxable Amount</th>
                        <th>CGST</th>
                        <th>SGST</th>
                        <th>IGST</th>
                        <th>Security Deposit</th>
                        <th>Receipt Amount</th>
                        <th>Payment Mode</th>
                        <th>Receipt Bank</th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody id="myTable">
                    {
                        accountRecieptList != '' && accountRecieptList != null ? (
                            accountRecieptList.map((data, i) => (
                                <tr>
                                    <td>{data.ReceiptNo}</td>
                                    <td>{data.ClientName}</td>
                                    <td>{data.ReceiptDate}</td>
                                    {/* <td>-</td> */}
                                    <td style={{ textAlign: 'right' }}>{data.BaseAmount != '' && data.BaseAmount != null ? data.BaseAmount.toFixed(2).toLocaleString("en-IN") : '-'}</td>
                                    <td style={{ textAlign: 'right' }}>{data.CGST != '' && data.CGST != null ? data.CGST.toFixed(2)
                                        .toLocaleString("en-IN") : '-'}</td>
                                    <td style={{ textAlign: 'right' }}>{data.SGST != '' && data.SGST != null ? data.SGST.toFixed(2)
                                        .toLocaleString("en-IN") : '-'}</td>
                                    <td style={{ textAlign: 'right' }}>{data.IGST != '' && data.IGST != null ? data.IGST.toFixed(2)
                                        .toLocaleString("en-IN") : '-'}</td>
                                    <td style={{ textAlign: 'right' }}>{data.SecurityDeposit != '' && data.SecurityDeposit != null ? data.SecurityDeposit?.toLocaleString("en-IN") : '-'}</td>
                                    {/* <td>-</td> */}
                                    <td style={{ textAlign: 'right' }}>{data.Amount != '' ? data.Amount?.toLocaleString("en-IN") : '-'}</td>
                                    <td>{data.PaymentMode}</td>
                                    <td>{data.ReceiptBank}</td>
                                    <td>
                                        <a onClick={() => this.downloadAccountReceipt(data.UserID, data.ReceiptID, data.tempReceiptNo)} style={{ cursor: 'pointer' }}><i class="fa fa-file-pdf-o" ></i></a>
                                    </td>
                                    <td class="text-right d-flex">
                                        <a title="Edit" class="btn btn-sm" onClick={() => this.updateAccountReceipt(data.UserID, data.ClientID, data.ReceiptID, data.ReceiptDetailID)}><i class="fa fa-edit action_btn_table"></i></a>
                                        <a
                                            title="View Order"
                                            class="btn btn-sm padding_0"
                                            onClick={() =>
                                                this.onPreviewNavigate(data.UserID, data.ClientID, data.ReceiptID, data.ReceiptDetailID)
                                            }
                                        >
                                            <i class="fa fa-eye action_btn_table"></i>
                                        </a>
                                        <a
                                            class="btn btn-sm delete_record"
                                            onClick={() => this.modalShow(data.UserID, data.ReceiptID)}
                                        ><i class="fa fa-trash action_btn_table"></i></a>
                                    </td>
                                </tr>
                            ))
                        ) : (<tr><td colSpan={12} className='text-center'>Record not found</td></tr>)
                    }
                </tbody>
            </table>
        )
    }

    render() {

        const { isLoading, accountRecieptList, currentPage, isAccordionExpanded, client, receiptFromDate, receiptToDate, receiptNo, show } = this.state

        console.log("accountRecieptList:, ", accountRecieptList)
        const recordsPerPage = 10
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        // Records to be displayed on the current page
        const currentRecords = accountRecieptList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(accountRecieptList.length / recordsPerPage)

        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <>

                    <main id="main">
                        <Header data={[22]} />
                        <section style={{ marginTop: "115px" }}>
                            <div class="container-fluid">
                                <div class="page-header">
                                    <h4 class="page-title">Receipts</h4>
                                </div>

                                <div class="search_accordion search_card">
                                    <div class="panel-group" id="accordion">
                                        <div class="panel panel-default">
                                            <div
                                                className="panel-heading accordion-toggle collapsed"
                                                data-toggle="collapse"
                                                data-parent="#accordion"
                                                data-target="#collapseOne"
                                                aria-expanded={isAccordionExpanded}
                                                onClick={() =>
                                                    this.setState({
                                                        isAccordionExpanded: !isAccordionExpanded,
                                                    })
                                                }
                                            >
                                                <h4 class="panel-title">Search</h4>

                                                <div class="searched_items">
                                                    <h5>Organizer Name : <span>{client != 'null' ? client : <></>}</span></h5>
                                                    <h5>Receipt Date : <span>{receiptFromDate != '' && receiptFromDate != 'null' ? moment(receiptFromDate).format('DD-MM-YYYY') : <></>}
                                                        &nbsp; - &nbsp;{receiptToDate != '' && receiptToDate != 'null' ? moment(receiptToDate).format('DD-MM-YYYY') : <></>}</span></h5>
                                                    <h5>Receipt No : <span>{receiptNo != 'null' ? receiptNo : <></>}</span></h5>
                                                </div>

                                            </div>
                                            <div
                                                id="collapseOne"
                                                className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                                                    }`}
                                            >
                                                <div class="panel-body">
                                                    <div class="row mr_0">
                                                        <div class="col-md-2">
                                                            <div class="form-group">
                                                                <label>Organizer Name</label>
                                                                <input type="text" class="form-control" placeholder="Client Name"
                                                                    value={client}
                                                                    onChange={(e) => this.setState({ client: e.target.value })}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div class="form-group">
                                                                <label>Receipt Date</label>
                                                                <div style={{ position: "absolute" }}>
                                                                    <DateRange
                                                                        editableDateInputs={true}
                                                                        onChange={(item) => this.chooseDate(item)}
                                                                        moveRangeOnFirstSelection={false}
                                                                        ranges={this.state.dateRange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <div class="form-group">
                                                                <label>Receipt No</label>
                                                                <input type="text" class="form-control" placeholder="Receipt No"
                                                                    value={receiptNo}
                                                                    onChange={(e) => this.setState({ receiptNo: e.target.value })}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <label>&nbsp;</label>
                                                            <div class="d-flex">
                                                                <a class="btn btn-primary search_btn" onClick={() => this.getAccountrecieptList()}>Search</a>
                                                                <a class="btn btn-primary search_btn ml-2" onClick={() => this.handleClear()}>clear</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="receipt_report ">
                                    <div class="row mr-0">
                                        <div class="col-md-6 padding_0">
                                            <h6>&nbsp;</h6>
                                        </div>
                                        <div class="col-md-6 padding_0">
                                            <div class="text-right">
                                                <button class="xl_download" onClick={() => this.addAccountReceipt()}>
                                                    <i class="fa fa-plus" title="Download XL"></i> New Receipt
                                                </button>
                                                {/* <button class="xl_download">
                                                        <i class="fa fa-file-excel-o" title="Download XL"></i> Export
                                                    </button> */}

                                            </div>
                                        </div>
                                    </div>


                                </div>
                                <div class="custom_table">
                                    <div class="hack1">
                                        <div class="hack2">
                                            {this.record(currentRecords)}
                                            {accountRecieptList.length > 0 ? <Pagination
                                                nPages={nPages}
                                                currentPage={currentPage}
                                                setCurrentPage={this.updateItem} /> : <></>}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </section>



                    </main>

                </>
                <ToastContainer />

                <Modal show={show} onHide={this.modalClose} size="md">
                    <Modal.Header>
                        <Modal.Title>Confirm Delete</Modal.Title>
                        <span
                            onClick={this.modalClose}
                            style={{ cursor: "pointer", fontWeight: "800" }}
                        >
                            X
                        </span>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="col-md-12">
                            <h3 className="pop_label">Do you really want to delete this record?</h3>
                        </div>

                    </Modal.Body>

                    <Modal.Footer style={{ padding: '5px 12px' }}>
                        <Button variant="success" onClick={() => this.deleteAccountReceiptList()}>Yes</Button>
                        <Button variant="secondary" onClick={this.modalClose}>
                            No
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>

        )
    }
}

export default withRouter(connect(null, { fill_action, accountReceipt_list_action, delete_accountReceipt_list_action, download_account_receipt_action })(AccountReceiptsList));